import { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import { safeColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const tooltip: RecursivePartial<{
    defaultProps?: TooltipPresentationProps;
}> = {
    defaultProps: {
        iconProps: {
            color: colorStrings.primaryMain,
            size: 16,
            css: css`
                margin: 0 4px;
            `,
        },
        cssOverrides: {
            tooltipContainer: css`
                box-shadow: 0 5px 20px ${safeColor(getColor(colorStrings.commonGlobalBlack)).rgb().alpha(0.2).string()};
                z-index: 999;
                border-radius: 5px;

                &::after {
                    border-color: ${getColor(colorStrings.commonGlobalWhite)} transparent transparent transparent;
                }
            `,
            tooltipBody: css`
                background-color: ${getColor(colorStrings.commonGlobalWhite)};
                color: ${getColor(colorStrings.textMain)};
            `,
        },
    },
};
